import { recordFromSnapshot } from 'utils/firebaseUtils'
import { registerHistoryListeners } from './history'
import Api from 'dashpoolApi'
// import _ from 'lodash'
import moment from 'moment'

// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_SETTINGS_ERROR = 'CREATE_SETTINGS_ERROR'
export const CREATE_SETTINGS_SUCCESS = 'CREATE_SETTINGS_SUCCESS'
export const DELETE_SETTINGS_ERROR = 'DELETE_SETTINGS_ERROR'
export const DELETE_SETTINGS_SUCCESS = 'DELETE_SETTINGS_SUCCESS'
export const UPDATE_SETTINGS_ERROR = 'UPDATE_SETTINGS_ERROR'
export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS'
export const UPDATE_CURRENT_PRICING_SUCCESS = 'UPDATE_CURRENT_PRICING_SUCCESS'
export const UPDATE_CURRENT_DATES_SUCCESS = 'UPDATE_CURRENT_DATES_SUCCESS'
export const UPDATE_SIZE_SUCCESS = 'UPDATE_SIZE_SUCCESS'
export const UPDATE_MENU_SUCCESS = 'UPDATE_MENU_SUCCESS'
export const UPDATE_PAYMENTS_SUCCESS = 'UPDATE_PAYMENTS_SUCCESS'
export const UPDATE_TABLETYPES_SUCCESS = 'UPDATE_TABLETYPES_SUCCESS'
export const UPDATE_TAXES_SUCCESS = 'UPDATE_TAXES_SUCCESS'
export const UPDATE_CHAT_SUCCESS = 'UPDATE_CHAT_SUCCESS'
export const UPDATE_ADMINCODE_SUCCESS = 'UPDATE_ADMINCODE_SUCCESS'
// const checkArray = (key) => {
//   return key === 'taxes' || key === 'payments' || key === 'menu'
// }
// const convertToArray = (obj) => {
//   return _.map(obj, (value, key) => {
//     if (key !== 'key') {
//       return ({
//         key,
//         ...value
//       })
//     }
//   }).filter(val => val !== void 0)
// }
// ------------------------------------
// Logic Actions
// ------------------------------------
export const refreshPayments = () => {
  return (dispatch, getState) => {
    const api = new Api(dispatch, getState)
    api.get('/refresh/payments').catch(err => {
      console.error(err)
    })
  }
}
export const refreshTaxes = () => {
  return (dispatch, getState) => {
    const api = new Api(dispatch, getState)
    api.get('/refresh/taxes').catch(err => {
      console.error(err)
    })
  }
}
export function startDay() {
  return (dispatch, getState) => {
    dispatch(
      updateSettings({
        currentDates: {
          isStarted: true,
          startDate: moment().format(),
          endDate: null
        }
      })
    )
  }
}
export function endDay() {
  return (dispatch, getState) => {
    dispatch(
      updateSettings({
        currentDates: {
          isStarted: false,
          startDate: null,
          endDate: moment().format()
        }
      })
    )
  }
}
export function changeAdminCode(newCode) {
  return dispatch => {
    dispatch(updateSettings({ adminCode: newCode }))
  }
}
export function changeChat(isEnabled) {
  return dispatch => {
    dispatch(updateSettings({ chatEnabled: isEnabled }))
  }
}
export function selectCurrentPricing(pricing) {
  return (dispatch, getState) => {
    dispatch(
      updateSettings({
        currentPricing: { ...pricing, updatedAt: moment().format() }
      })
    )
  }
}
export function changeCurrentPricing(selectedPricing, date) {
  return (dispatch, getState) => {
    dispatch(
      updateSettings({
        currentPricing: { ...selectedPricing, updatedAt: date }
      })
    )
  }
}
export function updateMapSize(size) {
  return (dispatch, getState) => {
    dispatch(updateSettings({ size: size }))
  }
}
export function createTaxes(taxes, newTaxes) {
  const newTaxesArray = [...taxes, newTaxes]
  return (dispatch, getState) => {
    dispatch(updateSettings({ taxes: newTaxesArray }))
  }
}
// ------------------------------------
// Basic Actions
// ------------------------------------

export function updateSettings(changes) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('settings').update(changes, error => {
      if (error) {
        console.error('ERROR @ updateSettings :', error)
        dispatch({
          type: UPDATE_SETTINGS_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerSettingsListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('settings')
    ref.child('currentPricing').on('value', snapshot =>
      dispatch({
        type: UPDATE_CURRENT_PRICING_SUCCESS,
        payload: snapshot.val()
      })
    )
    ref.child('currentDates').on('value', snapshot => {
      dispatch({
        type: UPDATE_CURRENT_DATES_SUCCESS,
        payload: snapshot.val()
      })
      const currentDates = snapshot.val()
      if (!getState().history.registered) {
        registerHistoryListeners()(dispatch, getState)
      }
      if (
        currentDates !== null &&
        currentDates.isStarted &&
        currentDates.startDate
      ) {
        const now = moment()
        if (now.diff(moment(currentDates.startDate), 'h') > 24) {
          dispatch(endDay())
        }
      }
    })
    ref.child('size').on('value', snapshot =>
      dispatch({
        type: UPDATE_SIZE_SUCCESS,
        payload: snapshot.val()
      })
    )
    ref.child('tableTypes').on('value', snapshot =>
      dispatch({
        type: UPDATE_TABLETYPES_SUCCESS,
        payload: snapshot.val()
      })
    )
    ref.child('adminCode').on('value', snapshot =>
      dispatch({
        type: UPDATE_ADMINCODE_SUCCESS,
        payload: snapshot.val()
      })
    )
    ref.child('chatEnabled').on('value', snapshot =>
      dispatch({
        type: UPDATE_CHAT_SUCCESS,
        payload: snapshot.val()
      })
    )
    ref.child('taxes').on('value', snapshot => {
      const taxes = []
      if (snapshot !== null) {
        snapshot.forEach(snap => {
          taxes.push(recordFromSnapshot(snap))
        })
      }
      dispatch({
        type: UPDATE_TAXES_SUCCESS,
        payload: taxes
      })
    })
    ref.child('payments').on('value', snapshot => {
      const payments = []
      if (snapshot !== null) {
        snapshot.forEach(snap => {
          payments.push(recordFromSnapshot(snap))
        })
      }
      dispatch({
        type: UPDATE_PAYMENTS_SUCCESS,
        payload: payments
      })
    })
    ref.child('menu').on('value', snapshot => {
      const menu = []
      if (snapshot !== null) {
        snapshot.forEach(snap => {
          menu.push(recordFromSnapshot(snap))
        })
      }
      dispatch({
        type: UPDATE_MENU_SUCCESS,
        payload: menu
      })
    })
  }
}

export const actions = {
  updateMapSize,
  updateSettings,
  registerSettingsListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_CURRENT_PRICING_SUCCESS]: (state, action) =>
    Object.assign({}, state, { currentPricing: action.payload }),
  [UPDATE_CURRENT_DATES_SUCCESS]: (state, action) =>
    Object.assign({}, state, { currentDates: action.payload }),
  [UPDATE_SIZE_SUCCESS]: (state, action) =>
    Object.assign({}, state, { size: action.payload }),
  [UPDATE_TAXES_SUCCESS]: (state, action) =>
    Object.assign({}, state, { taxes: action.payload }),
  [UPDATE_PAYMENTS_SUCCESS]: (state, action) =>
    Object.assign({}, state, { payments: action.payload }),
  [UPDATE_TABLETYPES_SUCCESS]: (state, action) =>
    Object.assign({}, state, { tableTypes: action.payload }),
  [UPDATE_MENU_SUCCESS]: (state, action) =>
    Object.assign({}, state, { menu: action.payload }),
  [UPDATE_CHAT_SUCCESS]: (state, action) =>
    Object.assign({}, state, { chatEnabled: action.payload }),
  [UPDATE_ADMINCODE_SUCCESS]: (state, action) =>
    Object.assign({}, state, { adminCode: action.payload }),
  [UPDATE_SETTINGS_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_SETTINGS_SUCCESS]: (state, action) =>
    Object.assign({}, state, { [action.payload.key]: null }),
  [DELETE_SETTINGS_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  currentDates: { isStarted: true, startDate: void 0, endDate: void 0 },
  currentPricing: null,
  size: { width: 100, height: 100 },
  adminCode: '',
  taxes: [],
  payments: [],
  menu: [],
  tableTypes: {},
  chatEnabled: false
}
export default function settingsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/settings.js